var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/question-mark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,9 C9.00029133,7.47442919 10.1454538,6.19201013 11.6612688,6.01975736 C13.1770839,5.8475046 14.5807925,6.84027747 14.9233788,8.32688466 C15.2659652,9.81349185 14.438322,11.3204764 13,11.829 C12.4004081,12.0409876 11.9996666,12.6080369 12,13.244 L12,14.25",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17.25 C11.7928932,17.25 11.625,17.4178932 11.625,17.625 C11.625,17.8321068 11.7928932,18 12,18 C12.2071068,18 12.375,17.8321068 12.375,17.625 C12.375,17.4178932 12.2071068,17.25 12,17.25 L12,17.25",
    id: "path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 12,
    cy: 12,
    r: 11.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuQuestionMark);
export default __webpack_public_path__ + "static/media/menu-question-mark.006b21f8d0c4416624d86fd70e431287.svg";
export { ForwardRef as ReactComponent };